import { Injectable } from '@angular/core';
import {
  FieldAgentClient, GetQuotesRequest, PagingParameters,
  SortParameters, SortParametersDirection, PortalSearchParametersSuper,
  GetOrdersRequest, SearchParamsRequest, PortalSearchParametersSuperPortalSearchParameterType,
  GetOpportunitiesRequest, IPortalSearchParametersSuper, Statement, GetStockTransfersRequest,
  WorksOrdersSearchRequest, GetPurchaseOrdersRequest, SearchParameters
} from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from './epbt-field-agent.service';
import { DocumentTypes, ModelType, GridFieldType } from 'ep-bt-controls';
import { IEpBtFaCardModel } from '../models/epbt-fa-card.model';
import { DocumentDetailModel } from '../models/document-detail.model';
import { EpbtFaSortService } from './epbt-fa-sort.service';
import { EpbtFaFilterService } from '../services/epbt-fa-filter.service';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaDocumentService {

  gridColumns: any[];
  cardColumns: IEpBtFaCardModel[];
  bistrackSettings: any;
  webTrackUser: any;
  documentDetail: DocumentDetailModel;
  startIndex = 0;
  selectedDocumentType: string;
  selectedDocumentTypeForDash: string;
  iPortalSearchParametersSuper: IPortalSearchParametersSuper = { isEmpty: true };
  fromDashbard = false;
  shortDateFormat: string;

  constructor(private client: FieldAgentClient, private faService: EpbtFieldAgentService,
    private sortService: EpbtFaSortService, private filterService: EpbtFaFilterService
  ) {
    // this.bistrackSettings = this.faService.getBisTrackSetting();
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      this.shortDateFormat = '{0:' + bistrackSettings.shortDateFormat + '}';
    });

    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
    //  this.selectedDocumentType = DocumentTypes.Opportunities;
    //  this.selectedDocumentTypeForDash = DocumentTypes.Quotes;
  }

  generateGridModelIEpGridColumn(documentType: string, modelType: string): any {
    this.gridColumns = [];
    this.cardColumns = [];
    switch (documentType) {
      case DocumentTypes.Opportunities:
        ModelType.GridModel == modelType ? this.generateGridModelForOpportunity() : this.generateCardModelForOpportunity();
        break;
      case DocumentTypes.Quotes:
        ModelType.GridModel == modelType ? this.generateGridModelForQuotes() : this.generateCardModelForQuotes();
        break;
      case DocumentTypes.Orders:
        ModelType.GridModel == modelType ? this.generateGridModelForOrders() : this.generateCardModelForOrders();
        break;
      case DocumentTypes.TemplateOrders:
        ModelType.GridModel == modelType ? this.generateGridModelForTemplateOrders() : this.generateCardModelForTemplateOrders();
        break;
      case DocumentTypes.CallOffOrders:
        ModelType.GridModel == modelType ? this.generateGridModelForCallofforder() : this.generateCardModelForCallofforder();
        break;
      case DocumentTypes.Invoices:
        ModelType.GridModel == modelType ? this.generateGridModelForInvoices() : this.generateCardModelForInvoices();
        break;
      case DocumentTypes.Credits:
        ModelType.GridModel == modelType ? this.generateGridModelForCredits() : this.generateCardModelForCredits();
        break;
      case DocumentTypes.Statements:
        ModelType.GridModel == modelType ? this.generateGridModelForStatement() : this.generateCardModelForStatement();
        break;
      case DocumentTypes.Stocktransfers:
        ModelType.GridModel == modelType ? this.generateGridModelForStocktransfers() : this.generateCardModelForStocktransfers();
        break;
      case DocumentTypes.PurchaseOrder:
        ModelType.GridModel == modelType ? this.generateGridModelForPurchaseOrders() : this.generateCardModelForPurchaseOrders();
        break;
      case DocumentTypes.WorkOrders:
        ModelType.GridModel == modelType ? this.generateGridModelForWorksOrders() : this.generateCardModelForWorksOrders();
        break;
      default:
        break;
    }
    return ModelType.GridModel == modelType ? this.gridColumns : this.cardColumns;
  }

  getDataFromApi(documentType: string, customer: any, searchString: string, index: number, subscribe: (document: any, recordsCount: number) => void) {
    this.startIndex = index;
    switch (documentType) {
      case DocumentTypes.Opportunities:
        try {
          this.client.getOpportunities(this.generateRequestForOpportunitys(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
          });
        } catch (ex) {
          console.log('getQuotesRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.Quotes:
        try {
          this.client.getQuotes(this.generateRequestForQuotes(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
          });
        } catch (ex) {
          console.log('getQuotesRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.Orders:
        try {
          this.client.getOrders(this.generateRequestForOrders(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
          });
        } catch (ex) {
          console.log('getOrdersRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.TemplateOrders:
        try {
          this.client.getTemplateOrders(this.generateRequestForTemplateOrders(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
          });
        } catch (ex) {
          console.log('getTemplateOrdersRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.CallOffOrders:
        try {
          this.client.getCallOffOrderHeaders(this.generateRequestForCallofforders(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.headers, documentsRes.totalHeaderCount);
          });
        } catch (ex) {
          console.log('getCallofforderRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.Invoices:
        try {
          this.client.getInvoices(this.generateRequestForInvoices(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
          });
        } catch (ex) {
          console.log('getInvoicesRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.Credits:
        try {
          this.client.getCreditNotes(this.generateRequestForCredits(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
          });
        } catch (ex) {
          console.log('getCreditsRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.Statements:
        try {
          this.client.getStatements(this.generateRequestForStatements(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
            if (documentsRes.lines) {
              for (let i = 0; i <= documentsRes.lines.length; i++) {
                const currentItem: Statement = documentsRes.lines[i];
                if (!currentItem.jobReference && currentItem.statementByJob && !currentItem.isSummaryStatement) {
                  documentsRes.lines[i].jobReference = 'Main';
                }
              }
            }
          });
        } catch (ex) {
          console.log('getCreditsRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.Stocktransfers:
        try {
          // console.log("stock documents")
          this.client.getStockTransfers(this.generateRequestForStocktransfers(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
            // console.log(documentsRes.lines, "resultcount")
          });
        } catch (ex) {
          console.log('getStocktransfersRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.PurchaseOrder:
        try {
          // console.log('PurchaseOrders start api')
          this.client.getPurchaseOrders(this.generateRequestForPurchaseOrders(customer, searchString)).subscribe(documentsRes => {
            subscribe(documentsRes.lines, documentsRes.resultCount);
            console.log(documentsRes, 'PurchaseOrders result count');
          });
        } catch (ex) {
          console.log('getStocktransfersRequest Error :-');
          console.log(ex);
        }
        break;
      case DocumentTypes.WorkOrders:
        try {
          this.client.getWorksOrders(this.generateRequestForWorksOrders(customer, searchString)).subscribe(documentsRes => {
            const lines = [];
            documentsRes.lines.forEach(s => {
              if (s.orderNumber == 0) {
                s.orderNumber = null;
                lines.push(s);
              } else {
                lines.push(s);
              }
            });
            subscribe(lines, documentsRes.resultCount);
            // console.log(documentsRes.lines, 'resultcount')
          });
        } catch (ex) {
          console.log('getWorksOrdersRequest Error :-');
          console.log(ex);
        }
        break;
      default:
        break;
    }
    return '';
  }

  // Quotes Start

  generateGridModelForQuotes() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'quoteNumber', title: 'QUOTE NUMBER', width: 30, hidden: false, type: GridFieldType.NumberWithNoComma },
      { field: 'orderStatusName', title: 'STATUS', width: 30, hidden: false },
      { field: 'jobRef', title: 'JOB REFERENCE', width: 20, hidden: false },
      { field: 'expiryDate', title: 'EXPIRY', width: 20, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'dateCreated', title: 'REQUIRED', width: 20, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMT', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
      { field: 'salesRepName', title: 'SALES REP', width: 30, hidden: false },
      { field: 'branchName', title: 'BRANCH', width: 30, hidden: false },
      { title: 'PDF', width: 20, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForQuotes() {

    this.cardColumns = [
      { field: 'quoteNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'quoteNumber', displayName: '', icon: '', isDownloadPDF: true },
    ];


    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }


    this.cardColumns.push(
      { field: 'orderStatusName', displayName: 'Status', icon: '' },
      { field: 'jobRef', displayName: 'Job Reference', icon: '' },
      { field: 'expiryDate', displayName: 'Expiry', icon: '', isDate: true },
      { field: 'dateCreated', displayName: 'Required', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total amt', icon: '', isCurrency: true },
      { field: 'salesRepName', displayName: 'Sales rep', icon: '' },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    );
  }

  generateRequestForQuotes(customerId: any, searchString: string): any {
    const getQuotesRequest = new GetQuotesRequest();
    getQuotesRequest.currentUser = this.webTrackUser;
    getQuotesRequest.currentUser.customer.customerId = customerId;
    // Paging
    getQuotesRequest.pagingParameters = new PagingParameters();
    getQuotesRequest.pagingParameters.index = this.startIndex;
    getQuotesRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // Sorting
    getQuotesRequest.sortParameters = new SortParameters();
    if (this.fromDashbard) {
      getQuotesRequest.sortParameters.sortColumn = this.sortService.dashboardQuoteSortValue; // "QuoteNumber";
      getQuotesRequest.sortParameters.direction = this.sortService.dashboardQuoteDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      getQuotesRequest.sortParameters.sortColumn = this.sortService.customerQuoteSortValue; // "QuoteNumber";
      getQuotesRequest.sortParameters.direction = this.sortService.customerQuoteDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // search and filter
    if (this.fromDashbard) {
      getQuotesRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.quotesDashboardFilter,
        this.filterService.selectedDashboardQuotesSearchType, searchString, 'QuoteNumber', 'DateCreated');
    } else {
      getQuotesRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.quotesFilter,
        this.filterService.selectedQuotesSearchType, searchString, 'QuoteNumber', 'DateCreated');
    }
    getQuotesRequest.alwaysShowAllQuotes = true;
    return getQuotesRequest;
  }
  // Quotes End

  // Orders Start

  generateGridModelForOrders() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'orderNumber', title: 'ORDER NUMBER', width: 30, hidden: false, type: GridFieldType.NumberWithNoComma },
      { field: 'orderStatus', title: 'STATUS', width: 30, hidden: false },
      { field: 'jobRef', title: 'JOB REFERENCE', width: 20, hidden: false },
      { field: 'dateRequired', title: 'REQUIRED', width: 20, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMT', width: 30, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
      { field: 'salesRepName', title: 'SALES REP', width: 30, hidden: false },
      { field: 'branchName', title: 'BRANCH', width: 30, hidden: false },
      { title: 'PDF', width: 30, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForOrders() {

    this.cardColumns = [
      { field: 'orderNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'orderNumber', displayName: '', icon: '', isDownloadPDF: true },
    ];

    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }

    this.cardColumns.push(

      { field: 'orderStatus', displayName: 'Status', icon: '' },
      { field: 'jobRef', displayName: 'Job Reference', icon: '' },
      { field: 'dateRequired', displayName: 'Required', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total Amt', icon: '', isCurrency: true },
      { field: 'salesRepName', displayName: 'Sales Rep', icon: '' },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    );



  }

  generateRequestForOrders(customerId: any, searchString: string): any {
    const getOrdersRequest = new GetOrdersRequest();
    getOrdersRequest.currentUser = this.webTrackUser;
    getOrdersRequest.currentUser.customer.customerId = customerId;
    // Paging
    getOrdersRequest.pagingParameters = new PagingParameters();
    getOrdersRequest.pagingParameters.index = this.startIndex;
    getOrdersRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // sorting
    getOrdersRequest.sortParameters = new SortParameters();

    if (this.fromDashbard) {
      getOrdersRequest.sortParameters.sortColumn = this.sortService.dashboardOrderSortValue; // "OrderNumber";
      getOrdersRequest.sortParameters.direction = this.sortService.dashboardOrderDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      getOrdersRequest.sortParameters.sortColumn = this.sortService.customerOrderSortValue; // "OrderNumber";
      getOrdersRequest.sortParameters.direction = this.sortService.customerOrderDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // SearchParameters
    if (this.fromDashbard) {
      getOrdersRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.ordersDashboardFilter,
        this.filterService.selectedDashboardOrdersSearchType, searchString, 'OrderNumber', 'DateTimeCreated');
    } else {
      getOrdersRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.ordersFilter,
        this.filterService.selectedOrdersSearchType, searchString, 'OrderNumber', 'DateTimeCreated');
    }
    getOrdersRequest.alwaysShowAllOrders = true;
    return getOrdersRequest;
  }
  // Orders End

  saveDocSearchValues(filters, selectedFilter, searchValue) {
    const item = filters.find(i => i.propertyName == selectedFilter);
    if (item) {
      item.searchValue = searchValue == undefined ? item.searchValue : searchValue;
      // item.searchText = '';
    } else {
      const parms = new PortalSearchParametersSuper();
      parms.propertyName = selectedFilter;
      parms.searchValue = searchValue;
      // parms.searchText = "First";
      filters.push(parms);
    }
  }

  updatePortalSearchParametersSuper(filters, searchType, searchString, propertyName1, propertyName2): PortalSearchParametersSuper {
    const searchParameters = new PortalSearchParametersSuper();
    if (searchType == propertyName1) {
      this.saveDocSearchValues(filters, searchType, searchString);
    }
    const parms = filters.find(item => item.propertyName == searchType);
    if (searchType == propertyName2) {
      searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchDateRangeParameters;
      searchParameters.searchStartingValue = parms ? parms.searchStartingValue : null;
      searchParameters.searchEndingValue = parms ? parms.searchEndingValue : null;
      searchParameters.searchStartingValue = searchParameters.searchStartingValue ? this.getLocalTime(searchParameters.searchStartingValue, true) : null;
      searchParameters.searchEndingValue = searchParameters.searchEndingValue ? this.getLocalTime(searchParameters.searchEndingValue, false) : null;
      searchParameters.dateFormatString = this.shortDateFormat;
      searchParameters.isEmpty = false;
    } else {
      searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchSingleParameters;
      searchParameters.isEmpty = parms && parms.searchValue == '' ? true : false;
    }
    searchParameters.propertyName = parms ? parms.propertyName : searchType;
    searchParameters.searchValue = parms ? parms.searchValue : '';
    return searchParameters;
  }

  // Template Orders Start
  generateGridModelForTemplateOrders() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'orderNumber', title: 'ORDER NUMBER', width: 25, hidden: false, type: GridFieldType.NumberWithNoComma },
      { field: 'description', title: 'DESCRIPTION', width: 25, hidden: false },
      { field: 'jobRef', title: 'JOB REFERENCE', width: 25, hidden: false },
      { field: 'expiryDate', title: 'EXPIRY', width: 30, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMT', width: 25, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
      { field: 'salesRepName', title: 'SALES REP', width: 25, hidden: false },
      { field: 'branchName', title: 'BRANCH', width: 25, hidden: false },
    ];
  }

  generateCardModelForTemplateOrders() {

    this.cardColumns = [
      { field: 'orderNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },

    ];

    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }


    this.cardColumns.push(
      { field: 'description', displayName: 'Description', icon: '' },
      { field: 'jobRef', displayName: 'Job Reference', icon: '' },
      { field: 'expiryDate', displayName: 'Expiry', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total amt', icon: '', isCurrency: true },
      { field: 'salesRepName', displayName: 'Sales rep', icon: '' },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    );

  }

  generateRequestForTemplateOrders(customerId: any, searchString: string): any {
    const paramsRequest = new SearchParamsRequest();
    paramsRequest.user = this.webTrackUser;
    paramsRequest.user.customer.customerId = customerId;
    // Paging
    paramsRequest.pagingParameters = new PagingParameters();
    paramsRequest.pagingParameters.index = this.startIndex;
    paramsRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // sorting
    paramsRequest.sortParameters = new SortParameters();

    if (this.fromDashbard) {
      paramsRequest.sortParameters.sortColumn = this.sortService.dashboardTempOrderSortValue; // "OrderNumber";
      paramsRequest.sortParameters.direction = this.sortService.dashboardTempOrderDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      paramsRequest.sortParameters.sortColumn = this.sortService.customerTempOrderSortValue; // "OrderNumber";
      paramsRequest.sortParameters.direction = this.sortService.customerTempOrderDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // search and filter

    if (this.fromDashbard) {
      paramsRequest.searchParameters = this.updateTempOrderPortalSearchParameters(this.filterService.tempOrdersDashboardFilter,
        this.filterService.selectedDashboardTempOrdersSearchType, searchString, 'OrderNumber');
    } else {
      paramsRequest.searchParameters = this.updateTempOrderPortalSearchParameters(this.filterService.tempOrdersFilter,
        this.filterService.selectedTempOrdersSearchType, searchString, 'OrderNumber');
    }
    return paramsRequest;
  }
  // Template Orders End

  updateTempOrderPortalSearchParameters(filters, searchType, searchString, propertyName1): PortalSearchParametersSuper {
    const searchParameters = new PortalSearchParametersSuper();
    if (searchType == propertyName1) {
      this.saveDocSearchValues(filters, searchType, searchString);
    }
    const parms = filters.find(item => item.propertyName == searchType);
    searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchSingleParameters;
    searchParameters.isEmpty = parms && parms.searchValue == '' ? true : false;
    searchParameters.propertyName = parms ? parms.propertyName : searchType;
    searchParameters.searchValue = parms ? parms.searchValue : '';
    return searchParameters;
  }

  // Invoices Start
  generateGridModelForInvoices() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'invoiceNumber', title: 'INVOICE NUMBER', width: 25, hidden: false, type: GridFieldType.NumberWithNoComma },
      { field: 'invoiceStatus', title: 'STATUS', width: 25, hidden: false },
      { field: 'jobRef', title: 'JOB REFERENCE', width: 25, hidden: false },
      { field: 'invoiceDate', title: 'INVOICE DATE', width: 30, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'dueDate', title: 'DUE DATE', width: 30, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMT', width: 25, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
      { field: 'branchName', title: 'BRANCH', width: 25, hidden: false },
      { title: 'PDF', width: 25, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForInvoices() {

    this.cardColumns = [
      { field: 'invoiceNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'invoiceNumber', displayName: '', icon: '', isDownloadPDF: true },
    ];

    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }

    this.cardColumns.push(
      { field: 'invoiceStatus', displayName: 'Status', icon: '' },
      { field: 'jobRef', displayName: 'Job Reference', icon: '' },
      { field: 'invoiceDate', displayName: 'Invoice Date', icon: '', isDate: true },
      { field: 'dueDate', displayName: 'Due Date', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total amt', icon: '', isCurrency: true },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    );


  }

  generateRequestForInvoices(customerId: any, searchString: string): any {
    const paramsRequest = new SearchParamsRequest();
    paramsRequest.user = this.webTrackUser;
    paramsRequest.user.customer.customerId = customerId;
    // Paging
    paramsRequest.pagingParameters = new PagingParameters();
    paramsRequest.pagingParameters.index = this.startIndex;
    paramsRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // sorting
    paramsRequest.sortParameters = new SortParameters();

    if (this.fromDashbard) {
      paramsRequest.sortParameters.sortColumn = this.sortService.dashboardInvoicesSortValue; // "OrderNumber";
      paramsRequest.sortParameters.direction = this.sortService.dashboardInvoicesDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      paramsRequest.sortParameters.sortColumn = this.sortService.customerInvoicesSortValue; // "OrderNumber";
      paramsRequest.sortParameters.direction = this.sortService.customerInvoicesDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // search and filter
    if (this.fromDashbard) {
      paramsRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.invoicesDashboardFilter,
        this.filterService.selectedDashboardInvoicesSearchType, searchString, 'InvoiceNumber', 'InvoiceDate');
    } else {
      paramsRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.invoicesFilter,
        this.filterService.selectedInvoicesSearchType, searchString, 'InvoiceNumber', 'InvoiceDate');
    }
    return paramsRequest;
  }
  // Invoices End

  // Credits Start
  generateGridModelForCredits() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'creditNoteNumber', title: 'CREDIT NOTE NUMBER', width: 25, hidden: false, type: GridFieldType.NumberWithNoComma },
      { field: 'creditNoteStatus', title: 'STATUS', width: 25, hidden: false },
      { field: 'jobRef', title: 'JOB REFERENCE', width: 25, hidden: false },
      { field: 'creditDate', title: 'CREDIT DATE', width: 30, hidden: false, editor: 'date', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMT', width: 25, hidden: false, editor: 'numeric', type: GridFieldType.Currency },
      { field: 'branchName', title: 'BRANCH', width: 25, hidden: false },
      { title: 'PDF', width: 25, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForCredits() {

    this.cardColumns = [
      { field: 'creditNoteNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'creditNoteNumber', displayName: '', icon: '', isDownloadPDF: true },
    ];

    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }

    this.cardColumns.push(
      { field: 'creditNoteStatus', displayName: 'Status', icon: '' },
      { field: 'jobRef', displayName: 'Job Reference', icon: '' },
      { field: 'creditDate', displayName: 'Credit Date', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total amt', icon: '', isCurrency: true },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    );


  }

  generateRequestForCredits(customerId: any, searchString: string): any {
    const paramsRequest = new SearchParamsRequest();
    paramsRequest.user = this.webTrackUser;
    paramsRequest.user.customer.customerId = customerId;
    // Paging
    paramsRequest.pagingParameters = new PagingParameters();
    paramsRequest.pagingParameters.index = this.startIndex;
    paramsRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // sorting
    paramsRequest.sortParameters = new SortParameters();

    if (this.fromDashbard) {
      paramsRequest.sortParameters.sortColumn = this.sortService.dashboardCreditSortValue; // "OrderNumber";
      paramsRequest.sortParameters.direction = this.sortService.dashboardCreditDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      paramsRequest.sortParameters.sortColumn = this.sortService.customerCreditSortValue; // "OrderNumber";
      paramsRequest.sortParameters.direction = this.sortService.customerCreditDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // search and filter
    if (this.fromDashbard) {
      paramsRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.creditDashboardFilter,
        this.filterService.selectedDashboardCreditSearchType, searchString, 'CreditNoteNumber', 'CreditDate');
    } else {
      paramsRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.creditFilter,
        this.filterService.selectedCreditSearchType, searchString, 'CreditNoteNumber', 'CreditDate');
    }

    return paramsRequest;
  }
  // Credits End

  // OPPORTUNITY GRID & CARD & API START

  generateGridModelForOpportunity() {
    this.gridColumns = [
      { field: 'subject', title: 'SUBJECT', width: 20, hidden: false, class: 'color-blue' },
      { field: 'probability', title: 'PROBABILITY', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Percentage },
      { field: 'status', title: 'STATUS', width: 20, hidden: false, class: 'color-blue' },
      { field: 'totalRevenueInCurrency', title: 'TOTAL REVENUE', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Currency },
      { field: 'estimatedCloseDate', title: 'EST CLOSE DATE', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'actualCloseDate', title: 'ACT CLOSE DATE', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date }
    ];
  }

  generateCardModelForOpportunity() {
    this.cardColumns = [
      { field: 'subject', isTitle: true, displayName: '', icon: '' },
      { field: 'probability', displayName: 'Probability', icon: '', isPercentage: true },
      { field: 'status', displayName: 'Status', icon: '' },
      { field: 'totalRevenueInCurrency', displayName: 'Total revenue', icon: '', isCurrency: true },
      { field: 'estimatedCloseDate', displayName: 'Est close date', icon: '', isDate: true },
      { field: 'actualCloseDate', displayName: 'Act close date', icon: '', isDate: true }
    ];
  }

  generateRequestForOpportunitys(customerId: any, searchString: string): any {
    const documentOpportunitiesRequest = new GetOpportunitiesRequest();
    documentOpportunitiesRequest.webTrackUser = this.webTrackUser;
    documentOpportunitiesRequest.webTrackUser.customer.customerId = customerId;
    // Paging
    documentOpportunitiesRequest.pagingParameters = new PagingParameters();
    documentOpportunitiesRequest.pagingParameters.index = this.startIndex;
    documentOpportunitiesRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;

    // Sorting
    documentOpportunitiesRequest.sortParameters = new SortParameters();
    if (this.fromDashbard) {
      documentOpportunitiesRequest.sortParameters.sortColumn = this.sortService.dashboardOpportunitySortValue; // "DateTimeCreated";
      documentOpportunitiesRequest.sortParameters.direction = this.sortService.dashboardOpportunityDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      documentOpportunitiesRequest.sortParameters.sortColumn = this.sortService.customerOpportunitySortValue; // "DateTimeCreated";
      documentOpportunitiesRequest.sortParameters.direction = this.sortService.customerOpportunityDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // Search parameters
    documentOpportunitiesRequest.searchBranch = this.filterService.selectedOpportunityBranchId ? this.filterService.selectedOpportunityBranchId.toString() : '-1';
    documentOpportunitiesRequest.searchType = this.filterService.selectedOpportunityStatusId ? this.filterService.selectedOpportunityStatusId.toString() : '-2';
    documentOpportunitiesRequest.searchText = searchString == undefined ? this.filterService.opportunitySearchValue : searchString;
    this.filterService.opportunitySearchValue = searchString == undefined ? this.filterService.opportunitySearchValue : searchString;
    // StatusID
    return documentOpportunitiesRequest;
  }
  // OPPORTUNITY GRID & CARD & API END


  // CALLOFFORDER GRID & CARD & API START

  generateGridModelForCallofforder() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'orderNumber', title: 'ORDER NUMBER', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.NumberWithNoComma },
      { field: 'orderStatus', title: 'STATUS', width: 20, hidden: false, class: 'color-blue' },
      { field: 'description', title: 'DESC', width: 20, hidden: false, class: 'color-blue' },
      { field: 'jobRef', title: 'JOB REFERENCE', width: 20, hidden: false, class: 'color-blue' },
      { field: 'expiryDate', title: 'EXPIRY', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'dateRequired', title: 'REQUIRED', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMT', width: 20, hidden: false, class: 'color-blue', editor: 'numeric', type: GridFieldType.Currency },
      { field: 'salesRepName', title: 'SALES REP', width: 20, hidden: false, class: 'color-blue' },
      { field: 'branchName', title: 'BRANCH', width: 20, hidden: false, class: 'color-blue' }
    ];
  }

  generateCardModelForCallofforder() {

    this.cardColumns = [
      { field: 'orderNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'orderNumber', displayName: '', icon: '', isDownloadPDF: true },
    ];


    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }

    this.cardColumns.push(
      { field: 'orderStatus', displayName: 'Status', icon: '' },
      { field: 'description', displayName: 'Desc', icon: '' },
      { field: 'jobRef', displayName: 'Job Reference', icon: '' },
      { field: 'expiryDate', displayName: 'Expiry', icon: '', isDate: true },
      { field: 'dateRequired', displayName: 'Required', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total amt', icon: '', isCurrency: true },
      { field: 'salesRepName', displayName: 'Sales rep', icon: '' },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    );


  }

  generateRequestForCallofforders(customerId: any, searchString: string): any {
    const documentCallofforderRequest = new SearchParamsRequest();
    documentCallofforderRequest.user = this.webTrackUser;
    documentCallofforderRequest.user.customer.customerId = customerId;
    // Paging
    documentCallofforderRequest.pagingParameters = new PagingParameters();
    documentCallofforderRequest.pagingParameters.index = this.startIndex;
    documentCallofforderRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;

    // Sorting
    documentCallofforderRequest.sortParameters = new SortParameters();
    documentCallofforderRequest.sortParameters.sortColumn = 'OrderNumber';
    documentCallofforderRequest.sortParameters.direction = SortParametersDirection.Ascending;
    // Search parameters
    if (this.fromDashbard) {
      documentCallofforderRequest.searchParameters = new PortalSearchParametersSuper();
      documentCallofforderRequest.searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchSingleParameters;
      documentCallofforderRequest.searchParameters.isEmpty = searchString == '' ? true : false;
      documentCallofforderRequest.searchParameters.propertyName = 'Customer';
      documentCallofforderRequest.searchParameters.searchValue = searchString == undefined ? this.filterService.selectedDashboardCalloffCustomer : searchString;
      this.filterService.selectedDashboardCalloffCustomer = searchString == undefined ? this.filterService.selectedDashboardCalloffCustomer : searchString;

    }
    return documentCallofforderRequest;
  }
  // CALLOFFORDER GRID & CARD & API END

  // STATEMENT GRID & CARD & API START

  generateGridModelForStatement() {
    this.gridColumns = [
      { field: 'customerCode', title: 'CUSTOMER CODE', width: 30, hidden: !this.fromDashbard },
      { field: 'name', title: 'CUSTOMER NAME', width: 30, hidden: !this.fromDashbard },
      { field: 'statementNumber', title: 'STATEMENT #', width: 20, hidden: false, class: 'color-blue' },
      { field: 'jobReference', title: 'JOB REFERENCE', width: 20, hidden: false, class: 'color-blue' },
      { field: 'generatedDateTime', title: 'DATE', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'closingBalance', title: 'CLOSING BALANCE', width: 20, hidden: false, class: 'color-blue', editor: 'numeric', type: GridFieldType.Currency }
    ];
  }

  generateCardModelForStatement() {

    this.cardColumns = [
      { field: 'statementNumber', isTitle: true, displayName: '', icon: '' },
      { field: 'statementNumber', displayName: '', icon: '', isDownloadPDF: true },
    ];

    if (this.fromDashbard) {
      this.cardColumns.push(
        { field: 'customerCode', displayName: 'Customer Code', icon: '' },
        { field: 'name', displayName: 'Customer Name', icon: '' },
      );
    }

    this.cardColumns.push(
      { field: 'jobReference', displayName: 'Job reference', icon: '' },
      { field: 'generatedDateTime', displayName: 'Date', icon: '', isDate: true },
      { field: 'closingBalance', displayName: 'Closing balance', icon: '', isCurrency: true }
    );

  }

  generateRequestForStatements(customerId: any, searchString: string): any {
    const documentStatementRequest = new SearchParamsRequest();
    documentStatementRequest.user = this.webTrackUser;
    documentStatementRequest.user.customer.customerId = customerId;
    // Paging
    documentStatementRequest.pagingParameters = new PagingParameters();
    documentStatementRequest.pagingParameters.index = this.startIndex;
    documentStatementRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;

    // Sorting
    documentStatementRequest.sortParameters = new SortParameters();

    if (this.fromDashbard) {
      documentStatementRequest.sortParameters.sortColumn = this.sortService.dashboardStatementSortValue;
      documentStatementRequest.sortParameters.direction = this.sortService.dashboardStatementDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      documentStatementRequest.sortParameters.sortColumn = this.sortService.customerStatementSortValue;
      documentStatementRequest.sortParameters.direction = this.sortService.customerStatementDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    // Search parameters
    if (this.fromDashbard) {
      documentStatementRequest.searchParameters = new PortalSearchParametersSuper();
      documentStatementRequest.searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchSingleParameters;
      documentStatementRequest.searchParameters.isEmpty = searchString == '' ? true : false;
      documentStatementRequest.searchParameters.propertyName = 'Customer';
      documentStatementRequest.searchParameters.searchValue = searchString == undefined ? this.filterService.selectedDashboardStatementsCustomer : searchString;
      this.filterService.selectedDashboardStatementsCustomer = searchString == undefined ? this.filterService.selectedDashboardStatementsCustomer : searchString;
    }
    // else {
    //   documentStatementRequest.searchParameters.isEmpty = true;
    //   documentStatementRequest.searchParameters.propertyName = 'StatementNumber';
    // }


    return documentStatementRequest;
  }
  // STATEMENT GRID & CARD & API END

  // STOCK TRANSFERS GRID & CARD & API START

  generateGridModelForStocktransfers() {
    this.gridColumns = [
      { field: 'orderNumber', title: 'ORDER NUMBER', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.NumberWithNoComma },
      { field: 'branchName', title: 'FROM BRANCH', width: 20, hidden: false, class: 'color-blue' },
      { field: 'toBranchName', title: 'TO BRANCH', width: 20, hidden: false, class: 'color-blue' },
      { field: 'viaBranchName', title: 'VIA BRANCH', width: 20, hidden: false, class: 'color-blue' },
      { field: 'dateRequired', title: 'REQUIRED', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'createdBy', title: 'CREATED BY', width: 20, hidden: false, class: 'color-blue' },
      { title: 'PDF', width: 20, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForStocktransfers() {
    this.cardColumns = [
      { field: 'orderNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'orderNumber', displayName: '', icon: '', isDownloadPDF: true },
      { field: 'branchName', displayName: 'From Branch', icon: '' },
      { field: 'toBranchName', displayName: 'To branch', icon: '' },
      { field: 'viaBranchName', displayName: 'Via branch', icon: '' },
      { field: 'dateRequired', displayName: 'Required', icon: '', isDate: true },
      { field: 'createdBy', displayName: 'Created by', icon: '' }
    ];
  }

  generateRequestForStocktransfers(customerId: any, searchString: string): any {
    const getStockTransfersRequest = new GetStockTransfersRequest();
    getStockTransfersRequest.currentUser = this.webTrackUser;
    getStockTransfersRequest.currentUser.customer.customerId = customerId;
    // Paging
    getStockTransfersRequest.pagingParameters = new PagingParameters();
    getStockTransfersRequest.pagingParameters.index = this.startIndex;
    getStockTransfersRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;

    // Sorting
    getStockTransfersRequest.sortParameters = new SortParameters();
    getStockTransfersRequest.sortParameters.sortColumn = this.sortService.dashboardStockSortValue; // "OrderNumber";
    getStockTransfersRequest.sortParameters.direction = this.sortService.dashboardStockDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    // Search parameters

    getStockTransfersRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.stockTransfersDashboardFilter,
      this.filterService.selectedDashboardstockTransfersSearchType, searchString, 'OrderNumber', 'DateRequired');

    getStockTransfersRequest.alwaysShowAllOrders = true;

    // StatusID
    return getStockTransfersRequest;
  }
  // STOCK TRANSFERS GRID & CARD & API END



  // PURCHASE ORDERS GRID & CARD & API START
  generateGridModelForPurchaseOrders() {
    this.gridColumns = [
      { field: 'purchaseOrderNumber', title: 'ORDER NUMBER', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.NumberWithNoComma },
      { field: 'supplierName', title: 'SUPPLIER', width: 20, hidden: false, class: 'color-blue' },
      { field: 'statusName', title: 'STATUS', width: 20, hidden: false, class: 'color-blue' },
      { field: 'orderType', title: 'TYPE', width: 20, hidden: false, class: 'color-blue' },
      { field: 'dateRequired', title: 'REQUIRED', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'totalAmount', title: 'TOTAL AMOUNT', width: 20, hidden: false, class: 'color-blue', editor: 'numeric', type: GridFieldType.Currency },
      { field: 'createdByName', title: 'CREATED BY', width: 20, hidden: false, class: 'color-blue' },
      { field: 'branchName', title: 'BRANCH', width: 20, hidden: false, class: 'color-blue' },
      { title: 'PDF', width: 20, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForPurchaseOrders() {
    this.cardColumns = [
      { field: 'purchaseOrderNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'purchaseOrderNumber', displayName: '', icon: '', isDownloadPDF: true },
      { field: 'supplierName', displayName: 'Supplier', icon: '' },
      { field: 'statusName', displayName: 'Status', icon: '' },
      { field: 'orderType', displayName: 'Type', icon: '' },
      { field: 'dateRequired', displayName: 'Required', icon: '', isDate: true },
      { field: 'totalAmount', displayName: 'Total Amount', icon: '', isCurrency: true },
      { field: 'createdByName', displayName: 'Created by', icon: '' },
      { field: 'branchName', displayName: 'Branch', icon: '' }
    ];
  }

  generateRequestForPurchaseOrders(customerId: any, searchString: string): any {
    const purchaseOrderRequest = new GetPurchaseOrdersRequest();
    purchaseOrderRequest.currentUser = this.webTrackUser;
    purchaseOrderRequest.currentUser.customer.customerId = customerId;
    // Paging
    purchaseOrderRequest.pagingParameters = new PagingParameters();
    purchaseOrderRequest.pagingParameters.index = this.startIndex;
    purchaseOrderRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // Sorting
    purchaseOrderRequest.sortParameters = new SortParameters();
    purchaseOrderRequest.sortParameters.sortColumn = 'PurchaseOrderNumber';
    purchaseOrderRequest.sortParameters.direction = SortParametersDirection.Descending;
    // Search parameters
    // purchaseOrderRequest.searchParameters = new PortalSearchParametersSuper();
    // purchaseOrderRequest.searchParameters.propertyName = 'PurchaseOrderNumber';
    // purchaseOrderRequest.searchParameters.isEmpty = searchString ? true : false;
    // purchaseOrderRequest.searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchSingleParameters;
    // purchaseOrderRequest.searchParameters.searchValue = searchString;

    purchaseOrderRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.purchaseOrderDashboardFilter,
      this.filterService.selectedDashboardPurchaseOrderSearchType, searchString, 'PurchaseOrderNumber', 'DateRequired');
    purchaseOrderRequest.alwaysShowAllOrders = true;

    return purchaseOrderRequest;
  }
  // PURCHASE ORDERS GRID & CARD & API END




  // WORKS ORDERS GRID & CARD & API START
  generateGridModelForWorksOrders() {
    this.gridColumns = [
      { field: 'worksOrderNumber', title: 'ORDER NUMBER', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.NumberWithNoComma },
      { field: 'displayStatus', title: 'STATUS', width: 20, hidden: false, class: 'color-blue' },
      { field: 'dateRequired', title: 'REQUIRED', width: 20, hidden: false, class: 'color-blue', type: GridFieldType.Date },
      { field: 'branchName', title: 'BRANCH', width: 20, hidden: false, class: 'color-blue' },
      { field: 'customerName', title: 'CUSTOMER', width: 20, hidden: false, class: 'color-blue' },
      { field: 'orderNumber', title: 'ORDER #', width: 20, hidden: false, class: 'color-blue' },
      { field: 'description', title: 'DESCRIPTION', width: 20, hidden: false, class: 'color-blue' },
      { title: 'PDF', width: 20, hidden: false, class: 'ep-pdf-icon', type: GridFieldType.DownloadPDF }
    ];
  }

  generateCardModelForWorksOrders() {
    this.cardColumns = [
      { field: 'worksOrderNumber', isTitle: true, displayName: '', icon: '', isNumberWithNoComma: true },
      { field: 'worksOrderNumber', displayName: '', icon: '', isDownloadPDF: true },
      { field: 'displayStatus', displayName: 'Status', icon: '' },
      { field: 'dateRequired', displayName: 'Required', icon: '', isDate: true },
      { field: 'branchName', displayName: 'Branch', icon: '' },
      { field: 'customerName', displayName: 'Customer', icon: '' },
      { field: 'orderNumber', displayName: 'Orders #', icon: '' },
      { field: 'description', displayName: 'Description', icon: '' }
    ];
  }

  generateRequestForWorksOrders(customerId: any, searchString: string): any {
    const getWorksOrdersSearchRequest = new WorksOrdersSearchRequest();
    getWorksOrdersSearchRequest.currentUser = this.webTrackUser;
    getWorksOrdersSearchRequest.currentUser.customer.customerId = customerId;
    // Paging
    getWorksOrdersSearchRequest.pagingParameters = new PagingParameters();
    getWorksOrdersSearchRequest.pagingParameters.index = this.startIndex;
    getWorksOrdersSearchRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // Sorting
    getWorksOrdersSearchRequest.sortParameters = new SortParameters();
    getWorksOrdersSearchRequest.sortParameters.sortColumn = 'worksOrderNumber';
    getWorksOrdersSearchRequest.sortParameters.direction = SortParametersDirection.Ascending;
    // Search parameters
    getWorksOrdersSearchRequest.searchParameters = this.updatePortalSearchParametersSuper(this.filterService.workOrderDashboardFilter,
      this.filterService.selectedDashboardWorkOrderSearchType, searchString, 'WorksOrderNumber', 'DateRequired');

    getWorksOrdersSearchRequest.alwaysShowAllOrders = true;

    // StatusID
    return getWorksOrdersSearchRequest;
  }
  // WORKS ORDERS GRID & CARD & API END

  getLocalTime(date, type) {
    if (type)
      date.setHours(0, 0, 0, 0);
    else
      date.setHours(23, 59, 59);
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - (offset * 60 * 1000));
  }

}
